import { postJson } from '@upgrade/ui-utils/api/fetch-json';
import * as RAS from '.';
export var createRequestBody = function createRequestBody() {
  var properties = RAS.getPropertiesCookie();
  return {
    assetId: properties.ras_asset_id ? properties.ras_asset_id : '',
    cookieId: RAS.getUuidCookie(),
    deviceInfo: properties.ras_device_v1,
    event: properties.ras_action,
    rewardProgramCode: properties.rp_code,
    sid: RAS.getSessionCookie(),
    subId: properties.sub_id,
    url: properties.ras_page_url,
    sharedId: properties.sharedid,
    partnerOfferId: properties.partner_offer_id,
    utmCode: {
      campaign: properties.utm_campaign,
      content: properties.utm_content,
      medium: properties.utm_medium,
      source: properties.utm_source,
      term: properties.utm_term
    },
    autoCollateral: {
      age: properties.vehicleage,
      mileage: properties.mileage,
      retailLTV: properties.retailltv
    },
    lightbox: {
      incomeBand: properties.income,
      modelId: properties.modelid
    }
  };
};
export var postRAS = function postRAS(endpoint, createRequestBodyFn) {
  return postJson({
    url: endpoint,
    baseUrl: null,
    data: createRequestBodyFn(),
    includeCorrelationId: false,
    parseJson: false,
    mode: 'cors'
  });
};
export var doRas = function doRas(endpoint, action, loanId) {
  var cookieOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var createRequestBodyFn = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : createRequestBody;
  RAS.ensureUuidCookies(cookieOptions);
  RAS.setPropertiesCookie(action, loanId, cookieOptions);
  return postRAS(endpoint, createRequestBodyFn);
};
export var doRasExperiment = function doRasExperiment(_ref) {
  var endpoint = _ref.endpoint,
    loanId = _ref.loanId,
    experimentName = _ref.experimentName,
    key = _ref.key,
    value = _ref.value;
  return postRAS(endpoint, function () {
    return {
      assetId: loanId,
      experimentName: experimentName,
      key: key,
      value: value
    };
  });
};